<template>
    <va-create-layout>
        <RefundEventShipmentItemFee-form
            :title="title"
            :item="item"
        ></RefundEventShipmentItemFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
